/* Agrarluft: Netto-Zeilen für clientseitig aktualisierte Preise.
   window.alVat = { bp: 1900, incl: true, currency: 'EUR', moneyFormat: '…' } (snippets/al-price-js.liquid).
   Netto = brutto / (1 + Satz), kaufmännisch gerundet – identisch zur Liquid-Rechnung (al-net-price). */
(function () {
  var V = window.alVat || {};
  function active() { return V.incl === true && V.bp > 0; }
  function net(cents) {
    var div = 10000 + V.bp;
    return Math.floor((cents * 20000 + div) / (2 * div));
  }
  function fmtAl(cents) {
    var s = (cents / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s[0] + ',' + s[1] + ' €';
  }
  function fmtShop(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && V.moneyFormat) {
      try { return Shopify.formatMoney(cents, V.moneyFormat); } catch (e) {}
    }
    return fmtAl(cents);
  }
  function fmt(cents, f) { return f === 'shop' ? fmtShop(cents) : fmtAl(cents); }
  function label(cents, f) { return fmt(cents, f) + ' netto'; }
  function rangeLabel(min, max, f) {
    if (typeof max !== 'number' || max === min) return label(net(min), f);
    return fmt(net(min), f) + ' – ' + fmt(net(max), f) + ' netto';
  }
  window.alNet = { active: active, net: net, label: label, rangeLabel: rangeLabel };

  // Nächstgelegene Netto-Zeile zum Auslöser (Quickshop-Modal, Produktkarte …) – nie die einer anderen Karte.
  function nearestNet(from) {
    for (var el = from; el && el !== document.documentElement; el = el.parentElement) {
      var hit = el.querySelector && el.querySelector('[data-al-net-price]');
      if (hit) return hit;
    }
    return null;
  }

  // 1) Empire-Varianten-Wechsel (Quickshop): „variant-change“ bubbelt nicht → capture-Phase.
  //    detail.variant = Variante oder false (keine gültige Auswahl → Empire zeigt Preisspanne).
  document.addEventListener('variant-change', function (e) {
    if (!active() || !e.detail) return;
    var el = nearestNet(e.target);
    if (!el) return;
    var v = e.detail.variant, p = e.detail.product;
    if (v && typeof v.price === 'number') {
      el.textContent = label(net(v.price), 'shop');
    } else if (p && typeof p.price_min === 'number') {
      el.textContent = rangeLabel(p.price_min, p.price_max, 'shop');
    }
  }, true);

  // 2) Add-to-cart-Flyout (Empire): Flyout wird in [data-site-header] eingehängt, direkt danach
  //    feuert „cartcount:update“ mit den /cart.js-Daten.
  function fillBanner(cart) {
    var banners = document.querySelectorAll('[data-site-header] [data-atc-banner]');
    var banner = banners[banners.length - 1];
    if (!banner) return;
    var sub = banner.querySelector('[data-al-atc-subtotal-net]');
    if (sub && typeof cart.total_price === 'number') sub.textContent = label(net(cart.total_price), 'shop');
    var line = banner.querySelector('[data-al-atc-net]');
    if (!line || !cart.items || !cart.items.length) return;
    var title = ((banner.querySelector('[data-atc-banner-product-title]') || {}).textContent || '').trim();
    var opts = ((banner.querySelector('[data-atc-banner-product-options]') || {}).textContent || '').trim();
    // Nur bei EINDEUTIGER Zuordnung (Titel + Optionen) – mehrere Produkte können gleich heißen
    var matches = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.product_title !== title) continue;
      var itOpts = (it.variant_options || []).filter(function (o) { return o !== 'Default Title'; }).join(', ');
      if (itOpts === opts) matches.push(it);
    }
    line.textContent = '';
    if (matches.length !== 1) return; // lieber keine als eine falsche Netto-Zeile
    var item = matches[0];
    // Empire zeigt original_price bzw. (rabattiert) final_price – Netto des tatsächlich zu zahlenden Stückpreises
    line.textContent = label(net(item.final_price), 'shop');
  }
  window.addEventListener('cartcount:update', function (e) {
    if (!active() || !e.detail) return;
    var cart = e.detail;
    setTimeout(function () { fillBanner(cart); }, 0);
  });
})();
